<template>
    <md-menu md-direction="bottom-end" md-align-trigger md-close-on-click>
        <md-button class="md-just-icon md-primary" md-menu-trigger>
            <md-icon>more_horiz</md-icon>
        </md-button>
        <md-menu-content>
            <li>
                <a @click="actionEdit">Edit</a>
            </li>
            <li>
                <md-tooltip v-if="!canResetPassword" md-direction="top" class="error">Wrong email</md-tooltip>
                <a :class="canResetPassword ? '' : 'disabled'" @click="actionResetPassword">Reset password</a>
            </li>
            <li>
                <!--<a @click="actionDelete">Delete</a>-->
                <a @click="actionActive">Activate/Deactivate</a>
            </li>
        </md-menu-content>
    </md-menu>
</template>

<script>
    export default {
        name: "UserMoreDropdown",
        props: {
            user: {
                type: Object,
                required: true,
            }
        }, computed: {
            canResetPassword() {
                return this.user.email && this.user.email.length > 0;
            },
        }, methods: {
            actionEdit() {
                let path = this.$enums.RoutePathEnum.USER_UPDATE;
                path = path.replace(':id', this.user.id);

                this.$router.push(path);
            },
            actionResetPassword() {
                let id = this.user.id;

                this.$api.resetPasswordByUserId({
                    segments: {
                        userId: id,
                    },
                })
            },
            actionDelete() {
                let id = this.user.id;
                this.$api.deleteUser({
                    segments: {
                        userId: id,
                    },
                }).then(() => {
                    this.$bus.emit('updateIndex')
                })
            },
            actionActive() {
                let id = this.user.id;
                this.$api.changeActiveUser({
                    segments: {
                        userId: id,
                    },
                }).then(() => {
                    this.$bus.emit('updateIndex')
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../old/scss/variables";

    .error {
        color: $error-color !important;
    }
</style>